import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { pageHref, money } from "../lib/format";
import SmartImage from "../components/SmartImage";
import ItemCard from "../components/ItemCard";
import ProductCard from "../components/ProductCard";
import { EmptyState, PageLoader } from "../components/States";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [data, setData] = useState(null);

  useEffect(() => {
    if (q.length < 2) {
      setData({ pages: [], items: [], products: [] });
      return;
    }
    setData(null);
    api
      .get("/search", { params: { q } })
      .then((r) => setData(r.data))
      .catch(() => setData({ pages: [], items: [], products: [] }));
  }, [q]);

  const empty =
    data && !data.pages.length && !data.items.length && !data.products.length;

  return (
    <div className="container-nq section-nq" data-testid="search-page">
      <p className="eyebrow">Search</p>
      <h1 className="mt-2 text-3xl font-bold md:text-4xl">
        Results for <span className="gold-text">{q}</span>
      </h1>

      {!data ? (
        <PageLoader />
      ) : empty ? (
        <div className="mt-8">
          <EmptyState
            title="No matches"
            message="Try a different keyword, or browse the full site index."
            action={<Link to="/site-index" className="btn-outline-nq mt-3">Site index</Link>}
          />
        </div>
      ) : (
        <div className="mt-10 space-y-12">
          {data.products.length > 0 && (
            <section>
              <h2 className="text-xl font-bold">Shop products ({data.products.length})</h2>
              <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                {data.products.map((p) => (
                  <ProductCard key={p.id} product={p} />
                ))}
              </div>
            </section>
          )}

          {data.items.length > 0 && (
            <section>
              <h2 className="text-xl font-bold">Catalogue ({data.items.length})</h2>
              <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {data.items.map((i) => (
                  <ItemCard key={i.id} item={i} />
                ))}
              </div>
            </section>
          )}

          {data.pages.length > 0 && (
            <section>
              <h2 className="text-xl font-bold">Pages ({data.pages.length})</h2>
              <div className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {data.pages.map((p) => (
                  <Link key={p.id} to={pageHref(p.id)} className="card-nq flex items-center gap-4 p-3">
                    <div className="w-16 shrink-0">
                      <SmartImage src={p.hero_image} alt={p.title} ratio="aspect-square" fit="contain" fallbackLabel={p.title} />
                    </div>
                    <span className="text-sm font-medium">{p.title}</span>
                  </Link>
                ))}
              </div>
            </section>
          )}
        </div>
      )}
    </div>
  );
}
